<template>
  <div class="head">
    <span @click="backFunc"
          :class="'back ' + (navInfo.custom? 'my-style': '')">
      返回
    </span>
    <span class="tit">{{navInfo.tit}}</span>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "head-nav",
  props: ["navInfo"],
  methods: {
    backFunc () {
      this.$emit('backFunc')
    }
  }
}
</script>

<style scoped lang="stylus">
.head
  position relative
  width 100%
  height 44px
  padding 0 10px
  line-height 44px
  text-align center
  box-sizing border-box

  .back
    position absolute
    left 10px
    top 0
    height 100%
    line-height 44px
    color #137CFD
    font-size 14px
    vertical-align middle
    font-weight bold

    &::before
      content ''
      display inline-block
      width 12px
      height 22px
      vertical-align middle
      background url('~@/assets/nav-back.png') no-repeat center center
      background-size 100%

  .tit
    color #212121
    font-size 18px
    font-weight bold

  .right
    position absolute
    right 10px
    top 0
    height 100%
    line-height 44px
</style>